import layoutSlice from "./LayoutSlice/index.js"
import authSlice from "./AuthSlice/index.js"
// import currentUserSlice from "./CurrentUserSlice"

export const rootReducer = {
  Layout: layoutSlice,
  auth: authSlice
  // CurrentUser: currentUserSlice,
}